// Firebase App is always required and must be first
import firebase from 'firebase/app';
import 'firebase/database';

const config = {
  apiKey: 'AIzaSyAIAySZ2kuznOYy74s8a4AKDJPzvtIahD0',
  authDomain: 'bitcoin-fork.firebaseapp.com',
  databaseURL: 'https://bitcoin-fork.firebaseio.com',
  projectId: 'bitcoin-fork',
  storageBucket: 'bitcoin-fork.appspot.com',
  messagingSenderId: '1063662448349',
};

firebase.initializeApp(config);

export const db = firebase.database;

export default firebase;



// WEBPACK FOOTER //
// ./src/vendor/firebase.js